<template>
  <div class="box-wrap" v-if="isHasCourse">
    <div class="box box-book">
      <div class="box-title" v-if="item.id>0 && item.name"><span>{{item.name}}</span></div>
      <div class="course-list">
        <dl v-for="(course,i) in item.courseList" :key="i" @click="toLisiter(course)">
          <dt>
            <img :src="course.thumbnailUrl">
            <div class="mask"></div>
            <i class="icon icon-play-w v-align"></i>
          </dt>
          <dd>
            <div class="left">
              <div class="sub-title" v-text="course.name"></div>
            </div>
            <a class="ting" v-if="course.pcFreeFlag == 1 && type == 1 && !getUserInfo.memberFlag && !isOrga">免费听读</a>
            <i class="icon icon-right" v-else></i>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';
import util from 'libs/util'
export default {
  computed: {
    ...mapGetters([
      'getUserInfo'
    ])
  },
  props: {
    type: {
      type: Number,
      default: 1
    },
    isHasCourse: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default () {
        return {
          courseList: []
        }
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isOrga: false
    }
  },
  mounted() {
    this.isOrga = util.getStorage('orgaId') ? true : false
  },
  methods: {
    toLisiter(item) {
      const query = this.$route.query;
      this.$user.checkIsLogin((isReplace) => {
        this.$gopage('book_course', {
          id: item.id,
          fromType: query.type
        }, isReplace);
      }, 1)
    }
  }
}
</script>
<style lang="less" scoped>
</style>